/**
 * TimelineEventCardMolecule - Card for displaying a single timeline event
 * Composes atoms to show event details with user attribution
 */

import React from 'react';
import { Card } from 'primereact/card';
import { useTranslation } from 'localization';
import NotificationTimestampAtom from '../../atoms/NotificationTimestamp/NotificationTimestampAtom';
import './TimelineEventCardMolecule.scss';

export interface TimelineEventCardMoleculeProps {
  stageName: string;
  actionLabel: string;
  timestamp: string;
  updatedBy: string;
  comment?: string;
  showComment?: boolean;
  className?: string;
}

const TimelineEventCardMolecule: React.FC<TimelineEventCardMoleculeProps> = ({
  stageName,
  actionLabel,
  timestamp,
  updatedBy,
  comment,
  showComment = true,
  className = '',
}) => {
  const { t, i18n } = useTranslation();

  return (
    <Card className={`timeline-event-card-molecule ${className}`}>
      <div className="event-header">
        <div className="event-stage-info">
          <h4 className="event-stage-name">{stageName}</h4>
          <span className="event-action">{actionLabel}</span>
        </div>
        <div className="event-time">
          <NotificationTimestampAtom
            timestamp={timestamp}
            format="relative"
          />
        </div>
      </div>

      <div className="event-metadata">
        <div className="event-user">
          <i className="pi pi-user" />
          <span>{updatedBy || t('common.unknown')}</span>
        </div>

        <div className="event-timestamp">
          <i className="pi pi-clock" />
          <span>
            {new Date(timestamp).toLocaleString(i18n.language, {
              dateStyle: 'medium',
              timeStyle: 'short',
            })}
          </span>
        </div>
      </div>

      {showComment && comment && (
        <div className="event-comment">
          <i className="pi pi-comment" />
          <p>{comment}</p>
        </div>
      )}
    </Card>
  );
};

export default TimelineEventCardMolecule;
